import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import s from "../EditorPositionsAndTrainingPrograms.less";

export const getEditorPATPColumns = (
  t: TFunction,
  options: string[]
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`patp.${option}`),
      dataIndex: option,
      key: option,
    };

    // Special render for code field
    if (option === "code") {
      return {
        ...baseColumn,
        render: (value: any, record: any) => (
          <span className={s.name_table}>
            {record.positions?.map((position) => position.code).join(", ")}
          </span>
        ),
      };
    }

    if (option === "names") {
      return {
        ...baseColumn,
        width: "80%",
        render: (value: any, record: any) => (
          <span className={s.name_table}>
            {record.positions?.map((position) => position.name).join(", ")}
          </span>
        ),
      };
    }

    // Default render
    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
